"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.masked = false;
    this.maskedValue = 'mmm';
  }
  created() {
    this.maskedValue = this.value + 'muba';
  }
  async toggleMask() {
    if (this.disabled) {
      this.$message({
        message: 'Operation not permitted!',
        type: 'warning'
      });
      return;
    }
    const masked = !this.masked;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 'dd'
})], default_1.prototype, "value", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 4
})], default_1.prototype, "length", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "disabled", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'Mask'
})], default_1);
var _default = exports.default = default_1;